import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import useCustomStyles from "../../hooks/useCustomStyles";
import { selectState } from "../../store/slices/themeSlice";

import { ClientType, PendingClientType } from "../../store/slices/clientsSlice";
import { useNavigate } from "react-router-dom";
import { formatDate, jsDate, normalizeBusinessName } from "../../utils";
import { accessCodesStyles } from "../../assets/styles/accessCodesStyles";
import HeaderTabs from "../clients/components/HeaderTabs";
import TableComponent from "../clients/components/fff";
import { ERROR_COLUMNS, withDescriptions } from "../../utils/columnDescriptions";
import { ContractType } from "../../store/actions/accessCodeActions";
import CustomButton from "../../components/CustomButton";
import AddNewClientModal from "../clients/components/AddNewClientModal";
import ShareAccessCodeClientModal from "../clients/components/ShareAccessCodeClientModal";
import { ErrorTriage, getAllErrorTriage } from "../../api/awsApis";

const ErrorsScreen = () => {
  const { theme } = useSelector(selectState);
  const classes = useCustomStyles(accessCodesStyles, theme);
  const navigate = useNavigate();
  const [errorTriage, setErrorTriage] = useState<ErrorTriage[]>([]);

  const errorTriageColumns = [
    { key: "firstSeen", label: "First Seen" },
    { key: "lastSeen", label: "Last Seen" },
    { key: "errorMessage", label: "Error Message" },
    { key: "occurrences", label: "Occurrences" },
    { key: "affectedUsersCount", label: "Affected Users" },
    { key: "status", label: "Status" },
    { key: "priority", label: "Priority" },
  ];
  const handleRowClick = (error: ClientType | ContractType | ErrorTriage) => {
    //console.log(JSON.stringify(client));
    navigate("/errorsDetails", { state: { error } });
    console.log("row press");
    // navigate("/errorsDetails");
  };
  const getPriority = (item: number) => {
    switch (item) {
      case 1:
        return "High";
      case 2:
        return "Medium";
      case 3:
        return "Low";
      default:
        return "Unknown";
    }
  };
  const getStatusDisplay = (item: string) => {
    switch (item) {
      case "OPEN":
        return "Open";
      case "IN_PROGRESS":
        return "In Progress";
      case "RESOLVED":
        return "Resolved";
      default:
        return "Unknown";
    }
  };
  // Mock data (based on your ErrorTriage type)

  useEffect(() => {
    const fetchErrorTriageData = async () => {
      try {
        const data = await getAllErrorTriage();
        setErrorTriage(data);
      } catch (err) {
        console.error("Failed to fetch error triage data:", err);
      }
    };

    fetchErrorTriageData();
  }, []);

  const formattedErrorTriage = errorTriage.map((error) => ({
    raw: error, // keep raw object for navigation
    ...error,
    status: getStatusDisplay(error.status),
    firstSeen: formatDate(error.firstSeen),
    lastSeen: formatDate(error.lastSeen),
    priority: getPriority(error.priority),
  }));
  return (
    <div className={classes.container}>
      <div className={classes.tableContainer}>
        <h2 className={classes.header}>ERRORS</h2>
      </div>

      <TableComponent
        columns={withDescriptions(errorTriageColumns, ERROR_COLUMNS)}
        // data={formattedErrorTriageData}
        data={formattedErrorTriage}
        // data={errorTriage}
        handleNavigate={handleRowClick}
        pagination={true}
        itemsPerPage={10}
      />
    </div>
  );
};

export default ErrorsScreen;
